import Header from "./Header";
import "../CSS/loginPage.css"
import { FiEye } from "react-icons/fi";
import { FiEyeOff } from "react-icons/fi";
import { useState } from "react";
import Footer from "./footer";
import { useDispatch, useSelector } from "react-redux";
import { login, logout } from "../reducers/loginReducers";
import { useNavigate } from "react-router-dom";



const LoginPage = () => {

    const [error1, setError1] = useState("");  // error1 is login email error validation
    const [error2, setError2] = useState("");  // error2 is signup email error validation
    const [error3, setError3] = useState("");  // error3 is password & confirm password match validation
    const [error4, setError4] = useState("");  // API Error
    const [userRole, setUserRole] = useState('S');
    const [inputType, setInputType] = useState("password")
    const [inputType1, setInputType1] = useState("password")
    const [isLogin, setIsLogin] = useState(true)


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onLoginClick = async () => {

        const email = document.getElementById("email-login")?.value;
        const password = document.getElementById("password-login")?.value;
        const data = {
            email, password
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }

        const apiUrl = "http://localhost:8080/api/customer/login";
        fetch(apiUrl, requestOptions).then(
            response => {
                return response.json();
            }
        ).then(data => {
            console.log(data)
            if (data.id) {
                dispatch(login(data));
                navigate("/")
                localStorage.setItem("infinity_user", JSON.stringify(data))
            }
            else {
                setError4(data.message)
            }


        }).catch(error => {
            setError4(error)
            console.error(error)
        });
    }

    const onRegisterClick = () => {
        const username = document.getElementById("username-reg")?.value;
        const email = document.getElementById("email-reg")?.value;
        const password = document.getElementById("password-reg")?.value;
        const data = {
            username, email, password, user_role: userRole
        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(data)
        }

        const apiUrl = "http://localhost:8080/api/customer/save";
        fetch(apiUrl, requestOptions).then(
            response => {
                return response.json();
            }
        ).then(data => {
            console.log(data)
            if (data.id) {
                dispatch(login(data));
                navigate("/")
                localStorage.setItem("infinity_user", JSON.stringify(data))
            }
            else {
                setError4(data.message)
            }
        }).catch(error => {
            setError4(error)
            console.error(error)
        });
    }

    const onEyeClick = (e) => {

        if (e.target.getAttribute("name") === "eyeOpen") {
            setInputType("text")
        }
        else {
            setInputType("password")
        }

    }
    const onEyeClick1 = (e) => {

        if (e.target.getAttribute("name") === "eyeOpen") {
            setInputType1("text")
        }
        else {
            setInputType1("password")
        }

    }


    const onLoginToggle = () => {
        setIsLogin(!isLogin)
        setError4("")
    }

    const handleLoginEmailBlur = (e) => {
        const email = e.target.value

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (email.trim() !== '' && !emailRegex.test(email)) {
            console.log("SignUp email is not valid");
            setError1("Email is not valid");
        } else {
            console.log("SignUp email is valid");
            setError1("");
        }
    };

    const handleSignUpEmailBlur = (e) => {
        const email = e.target.value;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (email.trim() !== '' && !emailRegex.test(email)) {
            console.log("SignUp email is not valid");
            setError2("Email is not valid");
        } else {
            console.log("SignUp email is valid");
            setError2("");
        }
    };

    const validatePassword = () => {
        const password = document.getElementById('password-reg')?.value;
        const confirmPassword = document.getElementById('conpassword')?.value;

        if (password.trim() !== '' && confirmPassword.trim() !== '' && password !== confirmPassword) {
            console.log("Passwords do not match");
            setError3("Passwords do not match");
        } else {
            console.log("Passwords match");
            setError3("");
        }

    };

    const handleUserRoleChange = (e) => {
        setUserRole(e.target.value);
    };



    return (
        <div>
            <Header />
            {isLogin ?
                <div className="login-image whole-background row">
                    <div className="login-background">
                        <h1>Login to your account</h1>
                        <div className="input-div">
                            <input type="text" id="email-login" name="email" placeholder="Email" className="input"
                                onBlur={handleLoginEmailBlur}
                            />
                        </div>
                        {error1 && <div className="error"> {error1}</div>}
                        <div className="input-div">
                            <input type={inputType} id="password-login" name="password" placeholder="Password" className="input-password" />
                            {inputType === "password" ?
                                <button kind="simple" className="icon-button" onClick={onEyeClick} name="eyeOpen" ><FiEye size="2em" className="eye" name="eyeOpen" /></button>
                                : <button kind="simple" className="icon-button" onClick={onEyeClick} name="eyeOff" ><FiEyeOff size="2em" className="eye" name="eyeOff" /></button>}
                        </div>
                        {/* <div> */}
                        <button type="button" onClick={(e) => onLoginClick(e)} className="login-button">Login</button>
                        {error4 && <div className="api-error"> {error4}</div>}
                        {/* </div> */}
                        <div><button type="button" onClick={onLoginToggle} className="login-small-button">Create an account</button></div>
                    </div>
                </div>
                :
                <div className="signup-image whole-background row">
                    {/* <img src="/kk7.gif" width="900px" height="585px" /> */}

                    <div className="login-background">
                        <h1>Sign Up</h1>
                        <div className="input-div">
                            <input type="text" id="username-reg" name="username" placeholder="Username" className="input" />
                        </div>
                        <div className="input-div">
                            <input type="text" id="email-reg" name="Emall" placeholder="Email" className="input"
                                onBlur={handleSignUpEmailBlur}
                            />
                        </div>
                        {error2 && <div className="error"> {error2}</div>}
                        <div className="input-div">
                            <input type={inputType} id="password-reg" name="password" placeholder="Enter Your Password" className="input-password"
                                onBlur={validatePassword}
                            />
                            {inputType === "password" ?
                                <button kind="simple" className="icon-button" onClick={onEyeClick} name="eyeOpen" ><FiEye size="2em" className="eye" name="eyeOpen" /></button>
                                : <button kind="simple" className="icon-button" onClick={onEyeClick} name="eyeOff" ><FiEyeOff size="2em" className="eye" name="eyeOff" /></button>}
                        </div>
                        {error3 && <div className="error"> {error3}</div>}

                        <div className="input-div">
                            <input type={inputType1} id="conpassword" name="conpassword" placeholder="Confirm your Password" className="input-password"
                                onBlur={validatePassword}
                            />
                            {inputType1 === "password" ?
                                <button kind="simple" className="icon-button" onClick={onEyeClick1} name="eyeOpen" ><FiEye size="2em" className="eye" name="eyeOpen" /></button>
                                : <button kind="simple" className="icon-button" onClick={onEyeClick1} name="eyeOff" ><FiEyeOff size="2em" className="eye" name="eyeOff" /></button>}
                        </div>
                        {error3 && <div className="error"> {error3}</div>}
                        <div className="input-div">
                            {/* User role dropdown */}
                            <select id="user-role" onChange={(e) => handleUserRoleChange(e)} className="input-select">
                                <option className="option-select" value="S">I am a student</option>
                                <option className="option-select" value="T">I am a teacher</option>
                                <option className="option-select" value="A">I am an admin</option>
                            </select>
                        </div>
                        <button type="button" onClick={(e) => onRegisterClick(e)} className="login-button">Sign Up</button>
                        {error4 && <div className="api-error"> {error4}</div>}
                        <div><button type="button" onClick={onLoginToggle} className="login-small-button">I am already a member</button></div>
                    </div>
                </div>

            }
            <Footer />
        </div>


    )
}

export default LoginPage;